import PropTypes from 'prop-types';
import React from 'react';

import DesktopNavMenu from './DesktopNavMenu';
import mainNavLinks from '../data/main';

const DesktopNavMenuMain = (props) => (
  <DesktopNavMenu links={mainNavLinks} role="navigation" {...props} />
);

DesktopNavMenuMain.defaultProps = {
  onNavListItemClick: null,
};

DesktopNavMenuMain.propTypes = {
  onNavListItemClick: PropTypes.func,
};

export default DesktopNavMenuMain;
